module.exports = __webpack_public_path__ + "img/default.1a9a410e.png";